var _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAchatsDeProduits = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.42 51.92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: ".32 10.91 17.96 .46 35.77 13.52 26.04 32.95 4.83 32.8 .32 10.91",
    fill: "#ffce00",
    opacity: 0.2,
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.1,40.77h-26.06l-5.21-18.26h36.8l-5.53,18.26ZM21.66,38.61h22.83l4.22-13.94h-31.03l3.98,13.94Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.37,41.14h-26.62l-5.42-19h37.79l-5.76,19ZM20.31,40.4h25.51l5.31-17.52H15.32l5,17.52ZM44.77,38.98h-23.38l-4.19-14.68h32.02l-4.45,14.68ZM21.94,38.24h22.27l4-13.19h-30.04l3.76,13.19Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.27,
    y: 21.27,
    width: 12.97,
    height: 2.16,
    transform: "translate(13.4 63.34) rotate(-71.42)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.94,29.31l-2.75-.92,4.37-12.99,2.75.92-4.37,12.99ZM48.13,27.92l1.34.45,3.9-11.59-1.34-.45-3.9,11.59Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.96,
    y: 15.63,
    width: 8.99,
    height: 2.16,
    transform: "translate(-.49 1.77) rotate(-1.79)",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.64,18.31l-.09-2.9,9.73-.31.09,2.9-9.73.31ZM52.31,16.13l.04,1.42,8.25-.26-.04-1.42-8.25.26Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.68,51.03c-2.54,0-4.61-2.07-4.61-4.61s2.07-4.61,4.61-4.61,4.61,2.07,4.61,4.61-2.07,4.61-4.61,4.61ZM26.68,43.96c-1.35,0-2.45,1.1-2.45,2.45s1.1,2.45,2.45,2.45,2.45-1.1,2.45-2.45-1.1-2.45-2.45-2.45Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.68,51.4c-2.75,0-4.98-2.24-4.98-4.98s2.24-4.98,4.98-4.98,4.98,2.24,4.98,4.98-2.24,4.98-4.98,4.98ZM26.68,42.17c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24ZM26.68,49.24c-1.56,0-2.82-1.27-2.82-2.82s1.27-2.82,2.82-2.82,2.82,1.27,2.82,2.82-1.27,2.82-2.82,2.82ZM26.68,44.33c-1.15,0-2.08.93-2.08,2.08s.93,2.08,2.08,2.08,2.08-.93,2.08-2.08-.93-2.08-2.08-2.08Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.33,51.03c-2.54,0-4.61-2.07-4.61-4.61s2.07-4.61,4.61-4.61,4.61,2.07,4.61,4.61-2.07,4.61-4.61,4.61ZM40.33,43.96c-1.35,0-2.45,1.1-2.45,2.45s1.1,2.45,2.45,2.45,2.45-1.1,2.45-2.45-1.1-2.45-2.45-2.45Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.33,51.4c-2.75,0-4.98-2.24-4.98-4.98s2.24-4.98,4.98-4.98,4.98,2.24,4.98,4.98-2.24,4.98-4.98,4.98ZM40.33,42.17c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24ZM40.33,49.24c-1.56,0-2.82-1.27-2.82-2.82s1.27-2.82,2.82-2.82,2.82,1.27,2.82,2.82-1.27,2.82-2.82,2.82ZM40.33,44.33c-1.15,0-2.08.93-2.08,2.08s.93,2.08,2.08,2.08,2.08-.93,2.08-2.08-.93-2.08-2.08-2.08Z",
    fill: "#1d1e1c",
    strokeWidth: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAchatsDeProduits);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/achats de produits.f600db0b9c39c8e5bad9d3fe9c172cb7.svg";